import React, { useEffect, useRef } from "react"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Button from "../ui/button/Button"

// import WindowContext from "../../contexts/WindowContext"
import image from "../../assets/images/headerPeople.png"
import style from "./Header.module.css"

gsap.registerPlugin(ScrollTrigger)

const Header = ({ colour, windowDimensions }) => {
  const header = useRef(null)
  const titles = useRef(null)
  const wheel = useRef(null)

  useEffect(() => {
    ScrollTrigger.create({
      trigger: header.current,
      pin: header.current,
      pinSpacing: false,
    })
    gsap.to(".headerArrive", {
      duration: 0.8,
      stagger: 0.2,
      scale: 1,
      opacity: 1,
      y: 0,
      delay: 0.5,
    })

    gsap.to(wheel.current, {
      scale: 0.5,
      opacity: 0.2,
      ease: "none",
      scrollTrigger: {
        trigger: header.current,
        scrub: true,
        start: "center top",
        end: "bottom top",
      },
    })

    gsap.to(titles.current, {
      scale: 1.2,
      yPercent: -50,
      autoAlpha: 0,
      ease: "none",
      scrollTrigger: {
        trigger: header.current,
        scrub: true,
        start: "0px",
        end: "center top",
      },
    })

    setTimeout(() => ScrollTrigger.refresh(), 300)
  }, [])

  // Transition the circle colour
  useEffect(() => {
    gsap.to("#headerCircle", { attr: { fill: colour }, duration: 0.8 })
  }, [colour])

  // useEffect(() => {
  // setScrollHeight(windowDimensions.height)
  // TODO: Update the timline (or window scroll) to match previous pos.
  // }, [windowDimensions])

  return (
    <header ref={header} className={style.header}>
      <div ref={wheel} className={style.wheel}>
        <svg
          className="headerArrive"
          viewBox={`0 0 ${windowDimensions.width} ${windowDimensions.height}`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <filter id="blurMe" y="-50%" height="200%" x="-50%" width="200%">
            <feGaussianBlur id="blurFilter" stdDeviation="100" />
          </filter>
          <circle
            id="headerCircle"
            cx={windowDimensions.width / 2}
            cy={windowDimensions.height / 2}
            r={Math.max(
              windowDimensions.width / 2,
              windowDimensions.height / 2
            )}
            fill="#09CCC4"
            filter="url(#blurMe)"
          />
        </svg>
      </div>

      <div className={style.titles} ref={titles}>
        <img className="headerArrive" src={image} alt="Connected people" />
        <h1 className="headerArrive">Rise, Collectively</h1>
        <h2 className="headerArrive">
          <span style={{ fontWeight: 800 }}>
            Fufil is a new life achievement platform.{" "}
          </span>
          <span>
            Make meaningful connections and track your progress as you grow
            together.
          </span>
        </h2>
        <a
          className="headerArrive"
          href="https://fufilapp.netlify.app/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Button
            customClass="headerArrive"
            label="GET STARTED"
            contained={true}
            outlined={true}
            secondary={true}
            pressed={() => {}}
          />
        </a>
      </div>
    </header>
  )
}
export default Header
